import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index.js";

window.popStateDetected = false;

window.addEventListener("popstate", () => {
  window.popStateDetected = true;
});

Vue.use(VueRouter);

import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import About from "../views/About.vue";
import Permisos from "../views/Permisos";
import DetallePermiso from "../views/DetallePermiso";
import NuevoPermiso from "../views/NuevoPermiso";
import EdicionPermiso from "../views/EdicionPermiso";
import Vacaciones from "../views/Vacaciones";
import DetalleVacaciones from "../views/DetalleVacaciones";
import EdicionVacaciones from "../views/EdicionVacaciones";
import NuevasVacaciones from "../views/NuevasVacaciones";
import Anticipos from "../views/Anticipos";
import DetalleAnticipo from "../views/DetalleAnticipo";

import ModificacionesDatosPersonales from "../views/ModificacionesDatosPersonales";
import NuevaModificacionDatosPersonales from "../views/NuevaModificacionDatosPersonales";
import DetalleModificacionDatosPersonales from "../views/DetalleModificacionDatosPersonales";

import DetalleAnuncio from "../views/DetalleAnuncio";
import NuevoAnticipo from "../views/NuevoAnticipo";
import DocumentosPersonales from "../views/DocumentosPersonales";
import DocumentosGenerales from "../views/DocumentosGenerales";
import MiPerfil from "../views/MiPerfil";
import SolicitudNuevaContrasenia from "../views/SolicitudNuevaContrasenia";
import RecuperacionContrasenia from "../views/RecuperacionContrasenia";
import ValoracionResponsableVacaciones from "../views/ValoracionResponsableVacaciones";
import Redireccion from "../views/Redireccion";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      auth: true,
    },
  },
  {
    path: "/redi",
    name: "Redireccion",
    component: Redireccion,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/permisos",
    name: "Permisos",
    component: Permisos,
    meta: {
      auth: true,
    },
  },
  {
    path: "/permisos/ver/:id_permiso",
    name: "DetallePermiso",
    component: DetallePermiso,
    meta: {
      auth: true,
    },
  },
  {
    path: "/permisos/editar/:id_permiso",
    name: "EdicionPermiso",
    component: EdicionPermiso,
    meta: {
      auth: true,
    },
  },
  {
    path: "/permisos/nuevo",
    name: "NuevoPermiso",
    component: NuevoPermiso,
    meta: {
      auth: true,
    },
  },
  {
    path: "/vacaciones",
    name: "Vacaciones",
    component: Vacaciones,
    meta: {
      auth: true,
    },
  },
  {
    path: "/vacaciones/ver/:id_vacaciones",
    name: "DetalleVacaciones",
    component: DetalleVacaciones,
    meta: {
      auth: true,
    },
  },
  // {
  // path: "/vacaciones/editar/:id_vacaciones",
  //   name: "EdicionVacaciones",
  //   component: EdicionVacaciones,
  //   meta:{
  //     auth: true
  //   }
  // },
  {
    path: "/vacaciones/nuevas",
    name: "NuevasVacaciones",
    component: NuevasVacaciones,
    meta: {
      auth: true,
    },
  },
  {
    path: "/anticipos",
    name: "Anticipos",
    component: Anticipos,
    meta: {
      auth: true,
    },
  },
  {
    path: "/anticipos/nuevo",
    name: "NuevoAnticipo",
    component: NuevoAnticipo,
    meta: {
      auth: true,
    },
  },
  {
    path: "/anticipos/ver/:id_anticipo",
    name: "DetalleAnticipo",
    component: DetalleAnticipo,
    meta: {
      auth: true,
    },
  },
  {
    path: "/modificaciones-datos-personales",
    name: "ModificacionesDatosPersonales",
    component: ModificacionesDatosPersonales,
    meta: {
      auth: true,
    },
  },
  {
    path: "/modificaciones-datos-personales/nueva",
    name: "NuevaModificacionDatosPersonales",
    component: NuevaModificacionDatosPersonales,
    meta: {
      auth: true,
    },
  },
  {
    path: "/modificaciones-datos-personales/ver/:id_modificacion",
    name: "DetalleModificacionDatosPersonales",
    component: DetalleModificacionDatosPersonales,
    meta: {
      auth: true,
    },
  },

  {
    path: "/anuncios/ver/:id_anuncio",
    name: "DetalleAnuncio",
    component: DetalleAnuncio,
    meta: {
      auth: true,
    },
  },
  {
    path: "/documentos-personales",
    name: "DocumentosPersonales",
    component: DocumentosPersonales,
    meta: {
      auth: true,
    },
  },
  {
    path: "/documentos-generales",
    name: "DocumentosGenerales",
    component: DocumentosGenerales,
    meta: {
      auth: true,
    },
  },
  {
    path: "/mi-perfil",
    name: "MiPerfil",
    component: MiPerfil,
    meta: {
      auth: true,
    },
  },
  {
    path: "/about",
    name: "About",
    component: About,
    meta: {
      auth: true, // ruta protegida
    },
  },
  {
    path: "/solicitud-nueva-contrasenia",
    name: "SolicitudNuevaContrasenia",
    component: SolicitudNuevaContrasenia,
  },
  {
    path: "/recuperacion-contrasenia",
    name: "RecuperacionContrasenia",
    component: RecuperacionContrasenia,
  },
  {
    path: "/valoracion-responsable-vacaciones/:id_vacaciones",
    name: "ValoracionResponsableVacaciones",
    component: ValoracionResponsableVacaciones,
  },
  {
    path: "/desdeApp",
  },
  {
    path: "*",
    component: Home,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

/*
https://portalempleado.casi.es/Account/ForgotPassword
https://portalempleado.casi.es/Account/ForgotPasswordConfirmation
https://portalempleado.casi.es/Account/ForgotPasswordNew?userId=dd3318f1-87fd-4f15-a249-0c1a5b249a04&code=tb0NZ%2BF8E7p4py4OmFvfrJFD4%2BpJDDx8p1j88qzCmBMsJcI7C118ml7GOfr9lbH5DX2Hug0Iq%2FXRmRZuy1XMLhbtOboTvDmXBGmINUp9HjgDqQbKVjTT%2BXsVnpEF9pph3SoMrRw0Fy6Y6SRe2ybRqk6b7HeRrujHkmz5rDkrICappT5Kl9ArMBnaTJcaMFxHmEW6X97xHdAPdFWCag%2B6og%3D%3D
https://portalempleado.casi.es/Account/ResetPasswordConfirmation
*/

router.beforeEach(async (to, from, next) => {
  // console.log(from.path);
  // console.log(to.path);
  //console.log(to.meta);

  console.log("store.state.modoApp", store.state.modoApp);
  console.log("window.popStateDetected", window.popStateDetected);

  const isItABackButton = window.popStateDetected;
  window.popStateDetected = false;

  if (from.path === "/" && store.state.modoApp && isItABackButton) {
    console.log("Saliendo...");
    const target =
      window["cordova_iab"] ??
      window["webkit"]?.messageHandlers["cordova_iab"] ??
      window["opener"] ??
      window["parent"] ??
      window;

    const data = JSON.stringify({ event: "closeWindow" });

    target.postMessage(data, "*");
  }

  if (to.meta.auth) {
    if (checkToken()) {
      // console.log('Hay token, continuar a (' + to.path + ')');
      next();
    }
    if (!checkToken()) {
      const loginpath = window.location.pathname;
      // console.log('No hay token, redireccionar a login. (' + to.path + ')');
      next({ name: "Login", query: { from: loginpath } });
    }
  }

  if (!to.meta.auth) {
    if (to.path === "/desdeApp") {
      store.commit("establecerToken", to.query.token || "");
      store.commit("establecerModoApp", true);
      if (to.query.path && to.query.path !== "/redi") {
        await store.dispatch("obtenerPerfil");
      }
      next({ path: to.query.path || "/" });
    }

    if (to.path === "/login") {
      store.commit("establecerModoApp", false);
      if (checkToken()) {
        // console.log('Hay token, continuar a (' + to.path + ')');
        next({ name: "Home" });
        return;
      }
    }
    next();
  }
});

store.subscribe((mutation, state) => {
  if (mutation.type == "establecerPerfil") {
    if (mutation.payload.bloqueo * 1) {
      router.replace("/documentos-generales");
    }
  }
});

router.afterEach((to, from) => {
  // console.log('from:', from);
  // console.log('to:', to);

  // console.log('to.meta:', to.meta);

  if (to.name !== "Login") {
    // console.log('vamos a renover el token...');
    store.dispatch("renovarToken");
  }

  if (
    !["Login", "Home", "DocumentosGenerales", "Redireccion"].includes(to.name)
  ) {
    if (checkBloqueo()) {
      router.replace("/documentos-generales");
    }
  }
});

function checkBloqueo() {
  return store.state.perfil.bloqueo * 1;
}

function checkToken() {
  // console.log('store.state.token:', store.state.token);
  return store.state.token != "";
}

export default router;
